import { logEvent } from './logGaEvent'

/**
 * Trigger GA4 tag on listings item select.
 * @param {*} listingAttributes - See "createItemList" in "./logGaEvent-select-item" for attributes
 * @param {*} selectedIndex - Stuff
 */
const logSelectItem = itinAttribute => {
  if (itinAttribute) {
    logEvent('view_item_list', itinAttribute)
  }
}

export { logSelectItem }
